import JSDB from '../fromKotlin/nk';

interface Customer {
    active: boolean;
    id: string;
    name: string;
    email: string;
    agent: string;
    phone: string;
    phone2: string;
    phone3: string;
    // Print State
    withBarcode: boolean;
    withReturns: boolean;
    withPrice: boolean;
    withValue: boolean;
    position: number;
    date?: Date;
    notes2: string;
    notes3: string;
    notes4: string;
    notes5: string;
    notes6: string;
    notes7: string;
    notes8: string;
    notes9: string;
    notes10: string;
    notes11: string;
    notes12: string;
    days_to_pay: number;
    // Address
    date_contact?: string;
    city: string;
    street: string;
    streetNumber: string;

    category: string;
    group?: string;
    paymentComments?: string;


    // Aux
    includeTax: boolean;
    noTaxClient: boolean;
    discount: number;
    min_order: number;
    min_order_sum: number;
    /** -1 block all returns, 0 no cap, >0 monthly return % cap. */
    return_pct: number;
    net_split: number;
    location: string;

    //
    contactName: string;
    contactName2: string;
    contactName3: string;
    businessId: string;
    businessName: string;
    /**
     * The client's own row values, never resolved through a network master. The client
     * card edits these; everything else should use the resolved businessId/businessName.
     */
    ownBusinessId?: string;
    ownBusinessName?: string;
    businessName2?: string
    nameEnglish?: string;
    addressEnglish?: string;
    externalId: string;
    comments?: string;
    arrivalInstructions?: string;
    cardImage?: number;
    image?: string;
    obligo: number;
    tax_note_type: number;
    priceControl: number;
    /** Availability menu client id (≤ -10); inherits that client's product availability. */
    availableControl: number;
    /** When true (1), online order apps block this client. */
    cofcLock: boolean;

    sunday: boolean | true;
    monday: boolean | true;
    tuesday: boolean | true;
    wednesday: boolean | true;
    thursday: boolean | true;
    friday: boolean | true;
    saturday: boolean | true;
    notes: boolean | true;
    visit: boolean | false;
    collector: string | undefined | null;
    driver: string | undefined | null;

    // external_data
    status?: string;
    edi_sup_id?: string,
    edi_client_id?: string,
    net_edi?: string,
    internal_sup_edi?: string,
    branch_number?: string

    from_hour?: String,
    to_hour?: String,
    link?: boolean,

    /** Saved Tranzila card token (reusable charge). */
    cc_token?: string;
    cc_expiry?: string;
    cc_holder_id?: string;

    nkObject: any;


}

// SERIALIZERS
export const serializePrintState = (c: Customer): number => Number(c.withBarcode) * 1 + Number(c.withReturns) * 2 + Number(c.withPrice) * 4 + Number(c.withValue) * 8;
export const serializeDays = (c: Customer): number => Number(c.sunday) + Number(c.monday) * 2 + Number(c.tuesday) * 4 + Number(c.wednesday) * 8 + Number(c.thursday) * 16 + Number(c.friday) * 32 + Number(c.saturday) * 64;
export const serializeAddress = (c: Customer): string =>
    c.city.length === 0 && c.street.length === 0 && c.streetNumber.length === 0
        ? ''
        : `${c.city},${c.street},${c.streetNumber.toString()}`.replace('"', '');
export const serializeTax = (c: Customer) => Number(c.includeTax);
export const serializeNoTaxClient = (c: Customer) => Number(c.noTaxClient);

// DE-SERIALIZERS
export const deserializePrintState = (ps: number): {
    withBarcode: boolean;
    withReturns: boolean;
    withPrice: boolean,
    withValue: boolean
} => ({
    withBarcode: Boolean(ps & 1),
    withReturns: Boolean(ps & 2),
    withPrice: Boolean(ps & 4),
    withValue: Boolean(ps & 8)
});


export const deserializeTax = (t: number) => Boolean(t);

export const deserializeCustomer = (c): Customer => {
    // A null client can appear when an id/branch reference isn't in the store
    // (deleted/inactive). Callers filter these out; guard so one bad ref doesn't
    // crash the whole page on c.getCity()/getName()/etc.
    if (!c) return null as unknown as Customer;
    let status: string | undefined = '';
    if (JSDB().hasBeenToday(c)) {
        status = 'חולק';
    } else if (JSDB().hasOrderToday(c)) {
        status = 'הזמנה פתוחה';
    }
    let cust = makeCustomer({
        active: c.active === 1,
        id: c.id,
        name: c.getName(),
        email: c.getEmail(),
        agent: c.getAgent(),
        phone: c.getPhone(),
        phone2: c.getSecondPhone(),
        phone3: c.getThirdPhone(),
        link: c.link,
        from_hour: c.from_hour,
        to_hour: c.to_hour,

        // Print State
        ...deserializePrintState(c.print_state),
        position: c.position,
        date: c.creation_time ? new Date(c.creation_time) : undefined,
        // Address
        city: c.getCity(),
        street: c.getStreet(),
        streetNumber: c.getStreetNumber(),
        category: c.category,
        days_to_pay: c.days_to_pay,
        notes2: c.notes2,
        notes3: c.notes3,
        notes4: c.notes4,
        notes5: c.notes5,
        notes6: c.notes6,
        notes7: c.notes7,
        notes8: c.notes8,
        notes9: c.notes9,
        notes10: c.notes10,
        notes11: c.notes11,
        notes12: c.notes12,
        date_contact: c.date_contact ? (c.date_contact) : undefined,


        // Aux
        includeTax: deserializeTax(c.getIncludeTax()),
        noTaxClient: deserializeTax(c.getNoTaxClient()),
        discount: c.getDiscount(),
        priceControl: c.price_control,
        availableControl: Number(c.available_control ?? 0),
        cofcLock: Number(c.cofc_lock ?? 0) === 1,

        //
        contactName: c.getPhoneContact(),
        contactName2: c.getSecondPhoneContact(),
        contactName3: c.getThirdPhoneContact(),
        businessId: c.getBusinessId(),
        businessName: c.getBusinessName(),
        ownBusinessId: c.getOwnBusinessId(),
        ownBusinessName: c.getOwnBusinessName(),
        businessName2: c.business_name,
        externalId: c.getExternalId(),
        status,
        location: c.location,
        sunday: c.isSunday(),
        monday: c.isMonday(),
        tuesday: c.isThusday(),
        wednesday: c.isWendesday(),
        thursday: c.isThursday(),
        friday: c.isFriday(),
        saturday:c.isSaturday(),
        notes: c.getNotes() === 1,
        visit: c.getNotes() === -1,
        collector: c.getCollector()?.user_name,
        driver: c.getDriver()?.user_name,
        comments: c.comments,
        arrivalInstructions: c.arrival_instructions || '',
        cardImage: Number(c.card_image ?? 0),
        // min_order:c.getMinOrder(),
        min_order: c.min_order ?? 0,
        min_order_sum: c.min_order_sum ?? 0,
        return_pct: Number(c.return_pct ?? 0),
        edi_sup_id: c.edi?.edi_sup_id,
        edi_client_id: c.edi?.edi_client_id,
        net_edi: c.edi?.net_edi,
        internal_sup_edi: c.edi?.internal_sup_edi,
        branch_number: c.edi?.branch_number,
        obligo: c.getObligo(),
        group: c.category2,
        // Read through the master: a member's own copy of net_split can be stale.
        net_split: Number(c.networkBillingMode?.() ?? c.net_split ?? 0),
        paymentComments: c.payment_notes,
        tax_note_type: c.tax_note_type,
        nameEnglish: c.name_english,
        addressEnglish: c.address_english,
        cc_token: (c.cc_token != null && String(c.cc_token).trim()) || undefined,
        cc_expiry: (c.cc_expiry != null && String(c.cc_expiry).trim()) || undefined,
        nkObject: c
    });
    cust.freeDay = c.days < 0
    return cust
};


export const makeCustomer = ({
                                 active = false,
                                 id = '',
                                 name = '',
                                 email = '',
                                 agent = '',
                                 phone = '',
                                 phone2 = '',
                                 phone3 = '',
                                 from_hour = undefined,
                                 to_hour = undefined,
                                 link = undefined,

                                 // Print State
                                 withBarcode = false,
                                 withReturns = false,
                                 withPrice = false,
                                 withValue = false,
                                 position = 0,
                                 date = undefined,
                                 // Address
                                 city = '',
                                 street = '',
                                 streetNumber = '',
                                 category = '',
                                 days_to_pay = 0,
                                 notes2 = '',
                                 notes3 = '',
                                 notes4 = '',
                                 notes5 = '',
                                 notes6 = '',
                                 notes7 = '',
                                 notes8 = '',
                                 notes9 = '',
                                 notes10 = '',
                                 notes11 = '',
                                 notes12 = '',
                                 date_contact = undefined,
                                 nameEnglish='',
                                    addressEnglish='',
                                 // Aux
                                 includeTax = false,
                                 noTaxClient = false,
                                 discount = 0,

                                 //
                                 contactName = '',
                                 contactName2 = '',
                                 contactName3 = '',
                                 businessId = '',
                                 businessName = '',
                                 ownBusinessId = '',
                                 ownBusinessName = '',
                                 businessName2 = '',
                                 externalId = '',
                                 status = '',
                                 sunday = true,
                                 monday = true,
                                 tuesday = true,
                                 wednesday = true,
                                 thursday = true,
                                 friday = true,
                                 saturday=true,
                                 notes = true,
                                 visit = false,
                                 collector = '',
                                 driver = '',
                                 comments = '',
                                 arrivalInstructions = '',
                                 cardImage = 0,
                                 image = undefined,
                                 min_order = 0,
                                 min_order_sum = 0,
                                 return_pct = 0,
                                 location = "",
                                 edi_sup_id = undefined,
                                 edi_client_id = undefined,
                                 net_edi = undefined,
                                 internal_sup_edi = undefined,
                                 branch_number = undefined,
                                 obligo = 0,
                                 priceControl = 0,
                                 availableControl = 0,
                                 cofcLock = false,
                                 paymentComments = undefined,
                                 group = undefined,
                                 tax_note_type = 0,
                                 net_split = 0,
                                 cc_token = undefined,
                                 cc_expiry = undefined,
                                 cc_holder_id = undefined,
                                 nkObject = null
                             }): Customer => ({
    active,
    id,
    name,
    email,
    agent,
    phone,
    phone2,
    phone3,
    withBarcode,
    withReturns,
    withPrice,
    position,
    date,
    city,
    street,
    streetNumber,
    includeTax,
    noTaxClient,
    discount,
    contactName,
    contactName2,
    contactName3,
    businessId,
    businessName,
    ownBusinessId,
    ownBusinessName,
    businessName2,
    externalId,
    status,
    sunday,
    monday,
    tuesday,
    wednesday,
    thursday,
    friday,
    saturday,
    notes,
    visit,
    collector,
    driver,
    comments,
    arrivalInstructions,
    cardImage,
    image,
    min_order,
    min_order_sum,
    return_pct,
    location,
    category,
    edi_sup_id,
    edi_client_id,
    net_edi,
    internal_sup_edi,
    branch_number,
    obligo,
    priceControl,
    availableControl,
    cofcLock,
    paymentComments,
    group,
    tax_note_type,
    days_to_pay,
    notes2,
    notes3,
    notes4,
    notes5,
    notes6,
    notes7,
    notes8,
    notes9,
    notes10,
    notes11,
    notes12,
    date_contact,
    net_split,
    withValue,
    from_hour,
    to_hour,
    link,
    nameEnglish,
    addressEnglish,
    cc_token,
    cc_expiry,
    cc_holder_id,
    nkObject
});

export default Customer;
